module.exports = __webpack_public_path__ + "static/media/Karma2.7010a6d4.jpg";